import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('openDialog');

export interface OpenDialogParam {
    key: string;
    okHandler: () => void;
    cancelHandler: () => void;
    userData: any;
}

export interface CloseDialogParam {
    key: string;
}

export const openDialogAction = actionCreator<OpenDialogParam>('open');

export const closeDialogAction = actionCreator<CloseDialogParam>('close');
